import { Text, Tooltip } from "@/atoms"

import { TFunction } from "@/hooks/useTranslation"
import { ArrowUp } from "@/icons"
import { Link } from "react-router-dom"
import styles from "./KortexVersionCell.module.scss"

export const KortexVersionCell = (t: TFunction) =>
  function KortexVersionCell(kortexVersion: string, items: any) {
    return (
      <div className={styles.container}>
        <Text className={styles.versionText}>{kortexVersion}</Text>
        {items.updateAvailable && items.platform && (
          // A cloud connection's stack updates from its settings, at the row's end
          <Tooltip title={t("deployments.cloudConnection.updateStack.help")}>
            <div className={styles.divider}>
              <ArrowUp className={styles.icon} />
              <Text className={styles.upgrade}>
                {t("deployments.cloudConnection.updateStack.label")}
              </Text>
            </div>
          </Tooltip>
        )}
        {items.updateAvailable && !items.platform && (
          <div className={styles.divider}>
            <ArrowUp className={styles.icon} />
            <Link
              to="/deployments/new-deployment"
              state={{ deployEnvFieldValue: items?.environmentName }}
            >
              <Text className={styles.upgrade}>{t("deployments.upgrade")}</Text>
            </Link>
          </div>
        )}
      </div>
    )
  }
